import ApiClient from "../ApiClient";
import NewUUID from "../../utils/randy/NewUUID";

/**
 * Returns groups the user owns OR participates in.
 * When options.bills is true, backend returns groups + bills for the primary group only (favorite or default).
 * Result includes bills_group_id and favorite_group_id.
 * @param {string} csrfToken
 * @param {{ bills?: boolean }} [options]
 * @returns {Promise<{ result: { groups: Array, bills: Array, favorite_group_id?: string, bills_group_id?: string } }|Array>}
 *   If options.bills is false/omitted, returns response.data.result (array of groups).
 *   If options.bills is true, returns response.data (result.groups, result.bills, result.favorite_group_id, result.bills_group_id).
 */
export const listUserGroups = async (csrfToken, options = {}) => {
    const url = options.bills ? '/api/groups?bills=true' : '/api/groups';
    const response = await ApiClient.get(url, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    if (options.bills) {
        return response.data;
    }
    return response.data.result;
};

export const setGroupFavorite = async (groupId, favorite, csrfToken) => {
    const response = await ApiClient.put(`/api/groups/${groupId}/favorite`, { favorite }, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const createGroup = async (name, csrfToken) => {
    const response = await ApiClient.post('/api/groups', {
        name: name,
    }, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result
}

export const getDefaultGroup = async (csrfToken) => {
    const response = await ApiClient.get('/api/groups/default', {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result
}

export const updateGroup = async (groupId, name, csrfToken) => {
    const response = await ApiClient.put(`/api/groups/${groupId}`, {
        name: name,
    }, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result
}

export const archiveGroup = async (groupId, csrfToken) => {
    const response = await ApiClient.put(`/api/groups/${groupId}/archive`, {}, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result
}

export const getGroupParticipantsExcludingBill = async (groupId, billId, csrfToken) => {
    const response = await ApiClient.get(`/api/groups/participants-excluding-bill?group_id=${groupId}&bill_id=${billId}`, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result
}

export const getGroupParticipants = async (groupId, csrfToken) => {
    const response = await ApiClient.get(`/api/groups/${groupId}/participants`, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result
}
